export default IconVinyl => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-vinyl" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M16 3.937a9 9 0 1 0 5 8.063" />
  <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  <path d="M20 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  <path d="M20 4l-3.5 10l-2.5 2" />
</svg>`;